interface Employee {
  employeeName: string;
  tnxPoint: number | null;
  loginPoint: number | null;
  showLoginPoint: boolean;
}

interface ReferralData {
  employeesReferred: Employee[];
}

export const calculateTotalPoints = (data: ReferralData): number => {
  let totalPoints = 0;

  data.employeesReferred.forEach(employee => {
    if (employee.tnxPoint !== null) {
      totalPoints += employee.tnxPoint;
    }

    if (employee.loginPoint !== null) {
      totalPoints += employee.loginPoint;
    }
  });

  return totalPoints;
};

export const searchEmployees = (employees: Employee[], searchTerm: string): Employee[] => {
  const normalizedSearchTerm = searchTerm.toLowerCase();
  const searchTermsArray = normalizedSearchTerm.split(' ');

  return employees.filter(employee => {
    const fullName = employee.employeeName.toLowerCase();
    const hasValidTnxPoint = employee.tnxPoint !== null;
    const hasValidLoginPoint = employee.loginPoint !== null;
    const hasCombinedShowLoginPoint = employee.showLoginPoint && (hasValidTnxPoint || hasValidLoginPoint);

    return (
      searchTermsArray.every(term => fullName.includes(term)) &&
      (hasCombinedShowLoginPoint || (hasValidTnxPoint && !employee.showLoginPoint)) &&
      fullName.trim() !== ''
    );
  });
};

export function showWhatsappShareForPic(isStausAjakanVar: boolean, item: Employee): boolean {
  if (isStausAjakanVar) {
    if (item.tnxPoint !== null && item.tnxPoint > 0 && item.loginPoint !== null && item.loginPoint > 0) return false;

    if (item.tnxPoint !== null && item.tnxPoint > 0 && item.showLoginPoint === false) return false;

    if (item.showLoginPoint && item.tnxPoint === null) return false;
  }
  return true;
}

export function getSelectedNames(
  departmentName: string | null,
  designationName: string | null,
  selectedDepartmentName: string | boolean,
  selectedDesignationName: string | boolean,
): string | boolean | undefined {
  if (!departmentName && !designationName) {
    return selectedDepartmentName && selectedDesignationName;
  }
  if (!departmentName) {
    return selectedDepartmentName;
  }
  if (!designationName) {
    return selectedDesignationName;
  }

  return false;
}

export function formatDepartmentAndDesignation(department: string | null, designation: string | null): string {
  const formattedDepartment = department || '';
  const formattedDesignation = designation || '';

  return `${formattedDepartment}${formattedDepartment && formattedDesignation ? ' - ' : ''}${formattedDesignation}`;
}
